import background from 'images/metanet-background.jpg';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import WrappedPasswordResetFormContainer from '../containers/PasswordResetFormContainer';

export interface IProps extends RouteComponentProps<{}> {}

export interface IState {
  showModal: boolean;
}

const PasswordResetPage = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const WrapForm = styled.div`
  width: 350px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

class PasswordResetView extends React.Component<IProps, IState> {
  render() {
    const backgroundStyle: any = {
      background: '50% 50% / cover no-repeat',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      backgroundImage: `url(${background})`
    };
    return (
      <PasswordResetPage>
        <b style={{ ...backgroundStyle }} />
        <WrapForm>
          <WrappedPasswordResetFormContainer />
        </WrapForm>
      </PasswordResetPage>
    );
  }
}

export default PasswordResetView;
